import { forwardRef, type FocusEventHandler } from "react";
import { Input } from "antd";
import type { InputRef } from "antd/es/input";
import { acceptPositiveInt } from "../rules";

export const PositiveIntInput = forwardRef<
  InputRef,
  {
    value?: string;
    onChange?: (next: string) => void;
    onBlur?: FocusEventHandler<HTMLInputElement>;
  }
>(function PositiveIntInput({ onChange, ...props }, ref) {
  return (
    <Input
      ref={ref}
      className="w-full"
      onChange={(e) => {
        if (acceptPositiveInt(e.target.value)) onChange?.(e.target.value);
      }}
      {...props}
    />
  );
});
